import { LAYER, layersMeta as layersMetaCore } from 'js/components/common/PopupManager/layers';

export * from 'js/components/common/PopupManager/layers';

export const layersMeta = {
    ...layersMetaCore,
    [LAYER.GAMES_INFO]: {
        disableNavigation: true
    },
    [LAYER.LOGIN]: {
        hideBelow: true
    }
};
